/**
 * @generated SignedSource<<c096f4f3dd3cc0e2d6bbfbfddade3894>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TaskProblemCreationTypeEnum = "first" | "original" | "second" | "third" | "%future added value";
export type TaskProblemTypeEnum = "copy" | "exam" | "private" | "problem_generator" | "pure" | "%future added value";
export type TaskOriginalUpdateDialog_taskQuery$variables = {
  id: string;
};
export type TaskOriginalUpdateDialog_taskQuery$data = {
  readonly task: {
    readonly firstChildren: ReadonlyArray<{
      readonly id: string;
      readonly sequence: number;
    }>;
    readonly id: string;
    readonly originalTask: {
      readonly sequence: number;
    } | null;
    readonly originalUpdateSiblingCandidates: ReadonlyArray<{
      readonly id: string;
      readonly originalTask: {
        readonly sequence: number;
      } | null;
      readonly sequence: number;
    }>;
    readonly problem: {
      readonly creationType: TaskProblemCreationTypeEnum | null;
      readonly problemType: TaskProblemTypeEnum;
    } | null;
    readonly secondChildren: ReadonlyArray<{
      readonly id: string;
      readonly sequence: number;
    }>;
    readonly sequence: number;
  };
};
export type TaskOriginalUpdateDialog_taskQuery = {
  response: TaskOriginalUpdateDialog_taskQuery$data;
  variables: TaskOriginalUpdateDialog_taskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequence",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "originalTask",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "problemType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creationType",
  "storageKey": null
},
v7 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v8 = {
  "alias": "firstChildren",
  "args": [
    {
      "kind": "Literal",
      "name": "kind",
      "value": "first"
    }
  ],
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "derivedTasks",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": "derivedTasks(kind:\"first\")"
},
v9 = {
  "alias": "secondChildren",
  "args": [
    {
      "kind": "Literal",
      "name": "kind",
      "value": "second"
    }
  ],
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "derivedTasks",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": "derivedTasks(kind:\"second\")"
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "originalTask",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskOriginalUpdateDialog_taskQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskProblem",
            "kind": "LinkedField",
            "name": "problem",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "originalUpdateSiblingCandidates",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskOriginalUpdateDialog_taskQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskProblem",
            "kind": "LinkedField",
            "name": "problem",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "originalUpdateSiblingCandidates",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d147abd189d824a1f044df5532d0f584",
    "id": null,
    "metadata": {},
    "name": "TaskOriginalUpdateDialog_taskQuery",
    "operationKind": "query",
    "text": "query TaskOriginalUpdateDialog_taskQuery(\n  $id: ID!\n) {\n  task(id: $id) {\n    id\n    sequence\n    originalTask {\n      sequence\n      id\n    }\n    problem {\n      problemType\n      creationType\n      id\n    }\n    firstChildren: derivedTasks(kind: \"first\") {\n      id\n      sequence\n    }\n    secondChildren: derivedTasks(kind: \"second\") {\n      id\n      sequence\n    }\n    originalUpdateSiblingCandidates {\n      id\n      sequence\n      originalTask {\n        sequence\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0556dbe972e7c8c527fd9f5a284313c7";

export default node;
